import Vue from 'vue';
import api from "@/api.js";
const form = {

    namespaced: true,
    state: {
        data: {

        }
    },


    getters: {
        getFormData: state => state.data
    },

    actions: {
        actionResetForm({
            commit
        }) {
            commit("resetForm");
        },
        actionSetForm({
            commit
        }, obj) {
            commit("setForm", obj);
        },
        actionRequest({
            commit,
            state,
            dispatch
        }, { page, uri, token, param }) {


            console.time("api run time ");

            //clear msg first
            dispatch('message/actionSetMessage', {
                message: null
            }, {
                root: true
            })
            dispatch('actionSetBlock', true, {
                root: true
            });

            api.request(
                page,
                "post",
                uri, {
                SessionID: token,
                //LocaleCode: this.$store.state.user.locale_code,
                Parameters: {
                    param: param
                }
            },
                function (r) {

                    //this.getDataSuccess(r);
                    console.timeEnd("api run time ");
                    console.log(r);
                    dispatch('actionSetBlock', false, {
                        root: true
                    });

                    commit("setForm",r.data.formData);
                },
                function (r) {
                    console.log(r);
                    dispatch('actionSetBlock', false, {
                        root: true
                    });
                    //this.loginFail(r);
                    //dispatch('message/actionSetMessage', {message:r},{root:true})
                }
            );
        }



    },
    // mutations
    mutations: {
        resetForm(state) {
            Vue.set(state, "data", {});
        },
        setForm(state, obj) {
            //array/obj must use Vue.set(object,key,val) for vue detection
            Vue.set(state, "data", obj);
            console.log(state.data);
        },
    }
}



export default form